import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '电影', path: '/category/dianying' },
  { name: '电视剧', path: '/category/dianshiju' },
  { name: '综艺', path: '/category/zongyi' },
  { name: '动漫', path: '/category/dongman' },
  { name: '纪录片', path: '/category/jilupian' },
  { name: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <span className="text-2xl md:text-3xl font-heading font-bold text-primary-500">
              芒果视频
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`whitespace-nowrap px-3 py-2 rounded-lg text-sm font-medium transition-colors duration-200 cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-primary-600 bg-primary-100/70'
                    : scrolled
                      ? 'text-foreground-700 hover:text-primary-500 hover:bg-background-200/70'
                      : 'text-foreground-50 hover:text-primary-300'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer"
            aria-label="菜单"
          >
            <i
              className={`text-xl ${
                scrolled ? 'text-foreground-800' : 'text-foreground-50'
              } ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}
            ></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`whitespace-nowrap px-4 py-3 rounded-lg text-sm font-medium transition-colors duration-200 cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-primary-600 bg-primary-100/70'
                    : 'text-foreground-700 hover:text-primary-500 hover:bg-background-200/70'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}